import React from 'react'
import './ViewJobUser.css';
import ChatImage from '../../../assets/images/user-icon4.png'
import New from '../../../assets/images/new1.png'

const ViewJobUser = ({ data, id }) =>
{

  const updatedAt = data.updated_at;
  const date = new Date(updatedAt);
  const formattedDate = date.toLocaleDateString("en-GB").replace(/\//g, "-");
  const formattedTime = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const formattedDateTime = `${formattedDate} ${formattedTime}`;

  return (

    <>
      <figure>
        {data.isNew && (
          <img src={New} alt='image' className='new-bedge' style={{ width: '40px', top: '5px', right: '5px', position: 'absolute' }} />
        )}
        <img src={ChatImage} alt='image' className='view-job-main-chat-section-img' />
      </figure>
      <div class="chat-person-detail">
        <div class="chat-person-name-date flex-wrap">
          <p>{data.name}</p>
          <span>{data.description.length > 30 ? `${data.description.slice(0, 30)}...` : data.description}</span>
        </div>
        <p class="chat-hint">
          <span class="chat-hint-text">{formattedDateTime}</span>
        </p>
      </div>
    </>
  )
}

export default ViewJobUser
